module.exports = __webpack_public_path__ + "media/app/assets/mailers/forum-48-primary-5f4f69b76780e34f455079435d817e6d.png";